import { pickLegalInfoRows } from "@/components/company/shared/company-side-panel-helpers";
import InlineCopyValue from "@/components/company/shared/inline-copy-value";
import KeyValueRow from "@/components/company/shared/key-value-row";
import RowsCard from "@/components/company/shared/rows-card";
import SectionHeaderWithIcon from "@/components/company/shared/section-header-with-icon";
import useCopyToClipboard from "@/hooks/useCopyToClipboard";
import { useTranslation } from "@/hooks/useTranslation";
import { CompanyDTO } from "@shaarp/common";
import { ScrollTextIcon } from "lucide-react";

type CompanyLegalInfoSectionProps = {
  readonly company: CompanyDTO;
  readonly className?: string;
};

export default function CompanyLegalInfoSection({
  company,
  className,
}: CompanyLegalInfoSectionProps) {
  const { t, currentLanguage } = useTranslation();
  const [copiedValue, copy] = useCopyToClipboard();
  const legalInfoRows = pickLegalInfoRows(company, t, currentLanguage);

  if (legalInfoRows.length === 0) return null;

  return (
    <section className={className}>
      <SectionHeaderWithIcon
        icon={ScrollTextIcon}
        title={t("company.insights.identity.title")}
      />
      <RowsCard>
        {legalInfoRows.map((row) => (
          <KeyValueRow key={row.key} label={row.label}>
            {row.copyValue ? (
              <InlineCopyValue
                value={row.value}
                copyValue={row.copyValue}
                copiedValue={copiedValue}
                onCopy={copy}
              />
            ) : (
              row.value
            )}
          </KeyValueRow>
        ))}
      </RowsCard>
    </section>
  );
}
